import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      width: '100%',
    };

    this.tabs = {
      width: '100%',
      borderBottom: (t) => `1px solid ${t.colors.gray}`,
    };

    this.tab = (isActive) => ({
      pb: [4, 6],
      px: [4, 5],
      position: 'relative',
      ':after': {
        content: '""',
        height: '1px',
        width: '100%',
        maxWidth: isActive ? '100%' : '0%',
        bg: 'text',
        position: 'absolute',
        left: 0,
        top: '100%',
        transition: 'max-width 0.15s ease-in-out',
      },
    });

    this.tabTitle = {
      variant: 'text.label.1',
      fontSize: [0, 2],
      lineHeight: 18,
    };

    this.content = (isActive) => ({
      display: isActive ? 'block' : 'none',
      width: '100%',
    });
  })()
);
